import Image from 'presentation/components/image/index.js';

const CompetitorIcon = props => {
    const {
        mojitoTools: { config },
        title,
        src,
    } = props;

    return src ? (
        <div className="ta-CompetitorIcon" style={config.container}>
            <Image config={config.image} src={src} title={title} alt={title} />
        </div>
    ) : null;
};

export default CompetitorIcon;
